import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './assets/css/index.css';
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import vRegion from 'v-region';
import infiniteScroll from 'vue-infinite-scroll'

Vue.use(vRegion)
Vue.use(Element)
Vue.use(infiniteScroll)
Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')